import gql from 'graphql-tag';

export type EnterpriseUserProgramAllowListQueryVariables = {
  programId: string;
  rosterIds: string[];
  text?: string;
};

export type EnterpriseUserProgramAllowListQueryResults = {
  ProgramInvitationsDomainAllowList: {
    queryDomainAllowList: EnterpriseUserProgramAllowListElement[];
  };
};

export type EnterpriseUserProgramAllowListElement = {
  emailDomain: string;
  rosterId: string;
  programId: string;
};

export const enterpriseUserProgramAllowListQuery = gql`
  query QueryDomainAllowList($programId: ID!, $rosterIds: [ID!]!, $text: String) {
    ProgramInvitationsDomainAllowList {
      queryDomainAllowList(programId: $programId, rosterIds: $rosterIds, searchText: $text) {
        emailDomain
        rosterId
        programId
      }
    }
  }
`;
